import tag from '@js/store/modules/tag';

export default {
    created() {
        if (!this.$store.hasModule('tag')) {
            this.$store.registerModule('tag', tag);
        }
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/item/tag-mixin.js